// extracted by mini-css-extract-plugin
module.exports = {"proofTree":"ProofTree_proofTree__3jAAd"};